var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 389,
    viewBox: "0 0 333 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_168)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_513_168)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 333,
    height: 389
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 332.887,
    height: 388.369,
    rx: 30,
    fill: "#AAEFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.854 419C177.703 419 146.276 411.408 119.573 396.223C93.2811 380.628 72.9459 356.62 58.5676 324.198C44.1892 291.777 37 250.122 37 199.233C37 161.886 42.1351 128.85 52.4054 100.122C63.0865 71.394 77.4649 47.3858 95.5405 28.0971C113.616 8.39808 134.157 -6.37621 157.162 -16.2257C180.578 -26.0752 205.022 -31 230.492 -31C301.973 -31 351.476 0.39535 379 63.1861L282.254 109.971C276.913 97.6594 269.724 88.4255 260.686 82.2695C252.059 76.1136 240.557 73.0356 226.178 73.0356C206.049 73.0356 189.205 81.0383 175.649 97.0438C162.503 113.049 155.313 135.826 154.081 165.375C165.995 153.884 179.346 145.676 194.135 140.751C208.924 135.416 224.33 132.748 240.351 132.748C263.768 132.748 285.951 137.673 306.903 147.523C328.265 157.372 345.519 172.352 358.665 192.461C372.222 212.16 379 237.194 379 267.564C379 295.06 372.222 320.3 358.665 343.282C345.519 366.264 326.622 384.732 301.973 398.685C277.324 412.228 247.951 419 213.854 419ZM212.622 324.198C225.768 324.198 237.065 320.094 246.513 311.886C256.373 303.268 261.303 291.982 261.303 278.029C261.303 262.844 256.989 250.737 248.362 241.709C240.146 232.27 228.232 227.55 212.622 227.55C197.832 227.55 185.919 232.27 176.881 241.709C167.843 251.148 163.324 262.639 163.324 276.182C163.324 292.598 168.254 304.705 178.113 312.502C188.384 320.3 199.886 324.198 212.622 324.198Z",
    fill: "#21C3E7",
    fillOpacity: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332.887,
    height: 388.369,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_513_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332.887,
    height: 388.369,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.8c432fa742e8a6b3f9e4ed341ab32f98.svg";
export { ForwardRef as ReactComponent };